export default __webpack_public_path__ + "static/media/fundamentos-fap.0e0af119.png";